// Tipe & util feed "penyelesaian" (task/subtask jadi selesai).
// Modul ini SENGAJA tanpa dependensi server — aman dipakai di client (badge,
// halaman) maupun di route handler (import type saja).

import type { Recurrence } from '@/lib/types'

export interface CompletionItem {
  id: string
  kind: 'task' | 'subtask'
  actorName: string | null     // nama orang yang menyelesaikan (assignee)
  department: string | null    // departemen orang tsb (fallback: departemen project)
  projectId: string | null
  projectName: string | null
  title: string                // judul task / subtask
  parentTitle: string | null   // utk subtask: judul task induk
  recurrence: Recurrence | null // terisi → item rutin (harian/mingguan/bulanan)
  completedAt: string          // ISO
}

// Penanda "terakhir dilihat" (epoch ms) — disimpan lokal per-browser.
export const NOTIF_SEEN_KEY = 'jal_notif_seen_at'
// Event window: SSE memberi tahu ada perubahan completions (badge → halaman).
export const NOTIF_CHANGED_EVENT = 'jal-completions-changed'
// Event window: pengguna sudah melihat halaman notifikasi (badge → 0).
export const NOTIF_SEEN_EVENT = 'jal-notif-seen'

/** Ambil timestamp "terakhir dilihat". Pertama kali → set ke sekarang (agar
 *  riwayat lama tidak dihitung sebagai "baru"). */
export function getSeenAt(): number {
  if (typeof window === 'undefined') return Date.now()
  try {
    const v = localStorage.getItem(NOTIF_SEEN_KEY)
    if (v) return Number(v) || 0
    const now = Date.now()
    localStorage.setItem(NOTIF_SEEN_KEY, String(now))
    return now
  } catch {
    return Date.now()
  }
}

/** Tandai "sudah dilihat" (sekarang) & beri tahu komponen lain (badge). */
export function markSeen(): void {
  if (typeof window === 'undefined') return
  try {
    localStorage.setItem(NOTIF_SEEN_KEY, String(Date.now()))
    window.dispatchEvent(new Event(NOTIF_SEEN_EVENT))
  } catch {
    /* abaikan */
  }
}

/** Jumlah item yang lebih baru dari `seenAt`. */
export function countUnseen(items: CompletionItem[], seenAt: number): number {
  return items.reduce((n, i) => (new Date(i.completedAt).getTime() > seenAt ? n + 1 : n), 0)
}
